{
  "AUTOMATION": {
    "HEADER": "Automation",
    "DESCRIPTION": "Automation can replace and streamline existing processes that require manual effort, such as adding labels and assigning conversations to the most suitable agent. This allows the team to focus on their strengths while reducing time spent on routine tasks.",
    "LEARN_MORE": "Learn more about automation",
    "HEADER_BTN_TXT": "Add Automation Rule",
    "LOADING": "Fetching automation rules",
    "ADD": {
      "TITLE": "Add Automation Rule",
      "SUBMIT": "Luo",
      "CANCEL_BUTTON_TEXT": "Peruuta",
      "FORM": {
        "NAME": {
          "LABEL": "Rule Name",
          "PLACEHOLDER": "Enter rule name",
          "ERROR": "Name is required"
        },
        "DESC": {
          "LABEL": "Kuvaus",
          "PLACEHOLDER": "Enter rule description",
          "ERROR": "Description is required"
        },
        "EVENT": {
          "LABEL": "Event",
          "PLACEHOLDER": "Please select one",
          "ERROR": "Event is required"
        },
        "PHASE": {
          "LABEL": "Vaihe"
        },
        "ORDER": {
          "LABEL": "Järjestys",
          "ERROR": "Järjestys vaaditaan"
        },
        "CONDITIONS": {
          "LABEL": "Conditions"
        },
        "ACTIONS": {
          "LABEL": "Toiminnot"
        }
      },
      "CONDITION_BUTTON_LABEL": "Add Condition",
      "ACTION_BUTTON_LABEL": "Add Action",
      "API": {
        "SUCCESS_MESSAGE": "Automation rule added successfully",
        "ERROR_MESSAGE": "Could not able to create a automation rule, Please try again later"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "PHASE": "Vaihe",
        "ORDER": "Järjestys",
        "NAME": "Nimi",
        "DESCRIPTION": "Kuvaus",
        "ACTIVE": "Active",
        "CREATED_ON": "Created on",
        "WAIT": "Odotus"
      },
      "404": "No automation rules found",
      "TABS": {
        "ALL": "Kaikki",
        "INSTANT": "Tapahtumasta",
        "DELAYED": "Viivästetyt"
      },
      "WAITS": "Odottaa {duration}"
    },
    "DELETE": {
      "TITLE": "Delete Automation Rule",
      "SUBMIT": "Poista",
      "CANCEL_BUTTON_TEXT": "Peruuta",
      "CONFIRM": {
        "TITLE": "Vahvista poistaminen",
        "MESSAGE": "Oletko varma että haluat poistaa ",
        "YES": "Kyllä, poista ",
        "NO": "Ei, säilytä "
      },
      "API": {
        "SUCCESS_MESSAGE": "Automation rule deleted successfully",
        "ERROR_MESSAGE": "Could not able to delete a automation rule, Please try again later"
      }
    },
    "EDIT": {
      "TITLE": "Edit Automation Rule",
      "SUBMIT": "Päivitä",
      "CANCEL_BUTTON_TEXT": "Peruuta",
      "API": {
        "SUCCESS_MESSAGE": "Automation rule updated successfully",
        "ERROR_MESSAGE": "Could not update automation rule, Please try again later"
      }
    },
    "CLONE": {
      "TOOLTIP": "Clone",
      "API": {
        "SUCCESS_MESSAGE": "Automation cloned successfully",
        "ERROR_MESSAGE": "Could not clone automation rule, Please try again later"
      }
    },
    "FORM": {
      "EDIT": "Muokkaa",
      "CREATE": "Luo",
      "DELETE": "Poista",
      "CANCEL": "Peruuta",
      "RESET_MESSAGE": "Changing event type will reset the conditions and events you have added below"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "You need to have atleast one condition to save",
      "CONTACT_CUSTOM_ATTR_LABEL": "Contact Custom Attributes",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "Conversation Custom Attributes"
    },
    "ACTION": {
      "DELETE_MESSAGE": "You need to have atleast one action to save",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "Enter your message here",
      "TEAM_DROPDOWN_PLACEHOLDER": "Select teams",
      "EMAIL_INPUT_PLACEHOLDER": "Enter email",
      "URL_INPUT_PLACEHOLDER": "Enter URL",
      "SENDER_DROPDOWN_PLACEHOLDER": "Valitse sähköpostikansio ja lähettäjän osoite",
      "SUBJECT_INPUT_PLACEHOLDER": "Sähköpostin aihe",
      "SMS_INBOX_DROPDOWN_PLACEHOLDER": "Valitse SMS-kansio, josta lähetetään",
      "SMS_MESSAGE_INPUT_PLACEHOLDER": "Kirjoita tekstiviestin teksti",
      "SMS_COUNTER": "{length}/{limit} merkkiä, {segments} SMS (ennen muuttujien täyttämistä)"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "Activate Automation Rule",
      "DEACTIVATION_TITLE": "Deactivate Automation Rule",
      "ACTIVATION_DESCRIPTION": "This action will activate the automation rule '{automationName}'. Are you sure you want to proceed?",
      "DEACTIVATION_DESCRIPTION": "This action will deactivate the automation rule '{automationName}'. Are you sure you want to proceed?",
      "ACTIVATION_SUCCESFUL": "Automation Rule Activated Successfully",
      "DEACTIVATION_SUCCESFUL": "Automation Rule Deactivated Successfully",
      "ACTIVATION_ERROR": "Could not Activate Automation, Please try again later",
      "DEACTIVATION_ERROR": "Could not Deactivate Automation, Please try again later",
      "CONFIRMATION_LABEL": "Yes",
      "CANCEL_LABEL": "No"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "Could not upload attachment, Please try again",
      "LABEL_IDLE": "Upload Attachment",
      "LABEL_UPLOADING": "Lähetetään...",
      "LABEL_UPLOADED": "Successfully Uploaded",
      "LABEL_UPLOAD_FAILED": "Upload Failed"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_REQUIRED": "Value is required",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998",
      "ACTION_PARAMETERS_REQUIRED": "Action parameters are required",
      "ATLEAST_ONE_CONDITION_REQUIRED": "At least one condition is required",
      "ATLEAST_ONE_ACTION_REQUIRED": "At least one action is required"
    },
    "ACTION_NOTICES": {
      "SKIP_AUTO_PRIORITY": "Tämä toiminto toimii vain, kun säännön vaiheeksi on asetettu ”Ennen tunnisteiden lisäystä”.",
      "SKIP_AUTO_LABELING": "Tämä toiminto toimii vain, kun säännön vaiheeksi on asetettu ”Ennen tunnisteiden lisäystä”.",
      "MOVE_CONVERSATION_TO_INBOX": "Sähköpostikansioon voi siirtää vain sähköposti- ja verkkochat-keskusteluja, ja verkkochatin vain, jos yhteystiedolla on sähköpostiosoite. Muuten keskustelu jää paikalleen ja sen sijaan lisätään sisäinen merkintä.",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Aloittaa yhteystiedon kanssa uuden keskustelun valitussa sähköpostikansiossa, lähettää viestin sähköpostilla ja merkitsee keskustelun ratkaistuksi. Näin tapahtuu aina, kun sääntö suoritetaan. Jos yhteystiedolla ei ole sähköpostiosoitetta, mitään ei lähetetä ja sen sijaan lisätään yksityinen muistiinpano.",
      "SEND_SMS_IN_NEW_CONVERSATION": "Aloittaa yhteystiedon kanssa uuden keskustelun valitussa SMS-kansiossa, lähettää viestin tekstiviestinä ja merkitsee keskustelun ratkaistuksi. Näin tapahtuu aina, kun sääntö suoritetaan. Viesti on pelkkää tekstiä ilman liitteitä. Jos yhteystiedolla ei ole puhelinnumeroa, mitään ei lähetetä ja sen sijaan lisätään yksityinen muistiinpano."
    },
    "NOTICES": {
      "AI_PROMPT": "Jokaisesta yksittäisestä arvioinnista veloitetaan.",
      "INCOMING_MESSAGES_COUNT": "Tämä viittaa keskustelun saapuvien viestien määrään.",
      "OUTGOING_MESSAGES_COUNT": "Tämä viittaa keskustelun lähtevien viestien määrään."
    },
    "PHASE": {
      "BEFORE_LABELING": "Ennen tunnisteiden lisäystä",
      "AFTER_LABELING": "Tunnisteiden lisäyksen jälkeen"
    },
    "NONE_OPTION": "None",
    "MESSAGE_TYPE_VALUES": {
      "INCOMING": "Saapuva viesti",
      "OUTGOING": "Lähtevä viesti",
      "PRIVATE": "Yksityinen muistiinpano",
      "AI_SUMMARY": "AI-yhteenveto"
    },
    "YES_NO_VALUES": {
      "YES": "Kyllä",
      "NO": "Ei"
    },
    "MESSAGE_SOURCE_TYPE_VALUES": {
      "FACEBOOK_MESSENGER": "Facebook Messenger",
      "INSTAGRAM_DM": "Instagram-yksityisviesti",
      "FACEBOOK_COMMENT": "Facebook-kommentti"
    },
    "EVENTS": {
      "CONVERSATION_CREATED": "Keskustelu luotu",
      "CONVERSATION_UPDATED": "Keskustelu päivitetty",
      "MESSAGE_CREATED": "Viesti luotu",
      "CONVERSATION_OPENED": "Keskustelu avattu",
      "CONVERSATION_RESOLVED": "Keskustelu ratkaistu",
      "PHONE_CALL_FINISHED": "Puhelu päättynyt"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Määritä edustajalle",
      "ASSIGN_TEAM": "Määritä tiimi",
      "ADD_LABEL": "Lisää tunniste",
      "REMOVE_LABEL": "Poista tunniste",
      "SEND_EMAIL_TO_TEAM": "Lähetä sähköposti tiimille",
      "SEND_EMAIL_TRANSCRIPT": "Lähetä keskustelu sähköpostitse",
      "SEND_EMAIL_TRANSCRIPT_WITH_DETAILS": "Lähetä yksityiskohtainen keskustelu sähköpostitse",
      "MUTE_CONVERSATION": "Mykistä keskustelu",
      "SNOOZE_CONVERSATION": "Torkuta keskustelu",
      "RESOLVE_CONVERSATION": "Ratkaise keskustelu",
      "OPEN_CONVERSATION": "Avaa keskustelu",
      "SEND_WEBHOOK_EVENT": "Lähetä webhook-tapahtuma",
      "SEND_ATTACHMENT": "Lähetä liite",
      "SEND_MESSAGE": "Lähetä viesti",
      "ADD_NOTE": "Lisää muistiinpano",
      "CHANGE_PRIORITY": "Muuta prioriteettia",
      "ADD_SLA": "Lisää SLA",
      "SKIP_AUTO_PRIORITY": "Ohita automaattinen prioriteetti",
      "SKIP_AUTO_LABELING": "Ohita automaattinen tunnisteiden lisäys",
      "AUTO_TRANSLATE": "Käännä viesti",
      "AUTO_TRANSLATE_CONVERSATION": "Käännä keskustelu",
      "MOVE_CONVERSATION_TO_INBOX": "Siirrä keskustelu kansioon",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Lähetä viesti uudessa keskustelussa",
      "SEND_SMS_IN_NEW_CONVERSATION": "Lähetä SMS uudessa keskustelussa",
      "STOP_PROCESSING_RULES": "Lopeta sääntöjen käsittely"
    },
    "ATTRIBUTES": {
      "AI_FILTER": "Tekoälysuodatin",
      "MESSAGE_TYPE": "Viestin tyyppi",
      "MESSAGE_CONTAINS": "Viestin sisältö",
      "EMAIL": "Yhteystiedon sähköposti",
      "INBOX": "Saapuneet-kansio",
      "CHANNEL_TYPE": "Saapuneet-kansion tyyppi",
      "CONVERSATION_LANGUAGE": "Keskustelun kieli",
      "PHONE_NUMBER": "Puhelinnumero",
      "STATUS": "Tila",
      "BROWSER_LANGUAGE": "Selaimen kieli",
      "MAIL_SUBJECT": "Sähköpostin aihe",
      "COUNTRY_NAME": "Maa",
      "MARKETPLACE_COUNTRY": "Kauppapaikan maa",
      "REFERER_LINK": "Viittaava linkki",
      "ASSIGNEE_NAME": "Vastaanottaja",
      "TEAM_NAME": "Tiimi",
      "PRIORITY": "Prioriteetti",
      "CALL_DIRECTION": "Puhelun suunta",
      "MISSED_CALL": "Vastaamaton puhelu",
      "MISSED_CALL_COUNT": "Vastaamattomien puheluiden määrä",
      "MESSAGE_SOURCE_TYPE": "Viestin lähdetyyppi",
      "INCOMING_MESSAGE_COUNT": "Saapuvien viestien määrä",
      "OUTGOING_MESSAGE_COUNT": "Lähtevien viestien määrä",
      "LABEL": "Tunniste",
      "EMAIL_RECIPIENTS": "Sähköpostin vastaanottaja",
      "EMAIL_AUTO_REPLY": "Sähköposti on automaattinen vastaus",
      "ATTACHMENT_EXTENSION": "Liitteen tiedostopääte",
      "EXTENSION": "Soitettu alanumero",
      "WORKING_HOURS": "Aukioloaikojen sisällä",
      "AGENT_REPLIED": "Agentti on vastannut tilan muutoksen jälkeen"
    },
    "WAIT": {
      "RUN_LABEL": "Suorita toiminnot",
      "INSTANT": "Tapahtuman yhteydessä",
      "DELAYED": "Viivästetty",
      "TRIGGER_LABEL": "Odota, kunnes",
      "TRIGGERS": {
        "CONVERSATION_STATUS": "Keskustelu pysyy tilassa",
        "CUSTOMER_UNRESPONSIVE": "Asiakas ei vastaa agentille",
        "AGENT_UNRESPONSIVE": "Asiakas ei saa vastausta agentilta"
      },
      "STATUS_LABEL": "Tila",
      "STATUSES": {
        "OPEN": "Avoin",
        "PENDING": "Odottaa",
        "SNOOZED": "Torkutettu",
        "RESOLVED": "Ratkaistu"
      },
      "DELAY_LABEL": "Odotusaika",
      "DELAY_ERROR": "Anna odotusaika väliltä 1 minuutti – 30 päivää",
      "DURATION": {
        "MINUTES": "{count} min",
        "HOURS": "{count} h",
        "DAYS": "{count} pv"
      },
      "EXPLANATION": {
        "CONVERSATION_STATUS": "Toiminnot suoritetaan, kun keskustelu on ollut tilassa {status} {duration}. Tilan muutos sitä ennen peruu ne. Tunnisteet, aukioloajat ja agentin vastaukset tarkistetaan, kun odotus päättyy.",
        "CUSTOMER_UNRESPONSIVE": "Toiminnot suoritetaan, kun asiakas ei ole vastannut agentin viestiin {duration}. Asiakkaan vastaus peruu ne; agentin uusi viesti aloittaa odotuksen alusta.",
        "AGENT_UNRESPONSIVE": "Toiminnot suoritetaan, kun asiakas on odottanut {duration} ilman agentin vastausta. Agentin vastaus peruu ne."
      }
    }
  }
}
